import i18n from '@/lib/i18n';
import { useAudioAnalizerStore } from '@/store/AudioAnalizerStore.ts';
import { MediaStreamAudioConsumer } from 'mind-sdk-web/lib/MediaStream';
import { MediaStreamAudioBuffer } from 'mind-sdk-web/lib/MediaStreamAudioBuffer';

function createAnalyserFromBuffer(buffer: MediaStreamAudioBuffer): AnalyserNode | null {
  try {
    const audioTrack = buffer.getTrack();
    const stream = new MediaStream([audioTrack]);

    const audioContext = new AudioContext();
    const analyser = audioContext.createAnalyser();
    const source = audioContext.createMediaStreamSource(stream);
    source.connect(analyser);

    return analyser;
  } catch (error) {
    console.error(i18n.t('events.audio.errorCreatingAnalyser'), error);
    return null;
  }
}

export class ParticipantAudioStreamListener implements MediaStreamAudioConsumer {
  constructor(private readonly participantId: string) {}

  onAudioBuffer(buffer: MediaStreamAudioBuffer | null): void {
    if (buffer) {
      const analyser = createAnalyserFromBuffer(buffer);
      if (analyser) {
        useAudioAnalizerStore.getState().addAnalyzer(this.participantId, analyser);
      }
    } else {
      useAudioAnalizerStore.getState().removeAnalyzer(this.participantId);
    }
  }
}

export class ActiveMicrophoneAudioStreamListener implements MediaStreamAudioConsumer {
  onAudioBuffer(buffer: MediaStreamAudioBuffer | null): void {
    if (buffer) {
      const analyser = createAnalyserFromBuffer(buffer);
      if (analyser) {
        useAudioAnalizerStore.getState().setActiveMicrophoneAnalyzer(analyser);
      }
    } else {
      useAudioAnalizerStore.getState().setActiveMicrophoneAnalyzer(null);
    }
  }
}
